<template>
    <div>
        <kgr-form-row
            :label="$t('E-Mail')"
            :error="error"
            field-name="clubEmployeeLogin"
        >
            <input
                v-model.trim="clubEmployee.contactEmail"
                type="text"
                class="kgr-input"
            />
        </kgr-form-row>

        <kgr-form-row
            :error="error"
            field-name="loginEnabled"
        >
            <kgr-checkbox
                v-model="clubEmployee.enabled"
                :label="$t('Login für diese Person erlauben')"
                :hint="$t('clubEmployee.loginEnabled.hint')"
                class="kgr-row mt1"
                :readonly="enabledDisabled"
            />
        </kgr-form-row>

        <div>{{ $t('Letzter Login: {date}', { date: clubEmployee.lastLogin }) }}</div>
    </div>
</template>

<script>
import Checkbox from '../common/form/checkbox/Checkbox';
import ClubEmployee from '../../js/dto/ClubEmployee';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';

export default {
    components: {
        'kgr-checkbox': Checkbox,
        'kgr-form-row': FormRow,
    },
    props: {
        clubEmployee: {
            type: ClubEmployee,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    computed: {
        enabledDisabled() {
            return this.clubEmployee.contactEmail === '';
        },
    },
    watch: {
        'clubEmployee.contactEmail': function (val) {
            if (val === '') {
                this.clubEmployee.enabled = false;
            }
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
